/*
 * @Description: 监控dom是否在可视范围内
 * @param {String} [targetClass='']  - 目标元素css选择器,必传
 * @param {Object||String} [containerDom=‘’]  - 目标元素所在的容器dom(只有在方法二中使用)或则目标元素的css选择器，唯一的,必传
 * @param {Function} [cb] - 回调函数，必传
 * @param {Object} option - 定制化参数
 * @property {Object} [option.observerOption=null] - IntersectionObserver的参数，
 * @property {Object} [option.BscrollObj=null] -  用了bscroll，传入滚动实例
 * @property {Number} [option.threshold=0.5] - 元素与容器交汇处的比例(只有在方法二中使用),(0-1),1表示整个目标元素都出现在容器中
 * @property {Boolean} [option.once=true] - 是否只曝光一次，默认是，是：注销监听在屏幕内事件，否：不注销注销监听在屏幕内事件
 * 注释：如果用到 bscroll，需要等bscroll初始化完成，再创建该实例
 */
class ViewPortLog {
  targetClass = ''; // 目标元素css选择器
  cb = null; //回调函数
  options = null; //传入的参数
  observer = null; //IntersectionObserver的实例
  timeout = null; //滚动防抖和截流定时器
  containerDom = null; //元素所在的容器dom(只有在方法二中使用)
  domEleClient = {}; //元素所在容器dom的BoundingClientRect
  listTargetIdArray = []; //所有目标元素的targetId集合,判断目标数据是否有新增
  BscrollObj = null; //bscroll滚动实例,
  scrollAllFn = null; //scroll 定义的方法
  targetIdArray = []; //已曝光的dom元素集合
  once = true; // 是否只曝光一次, 默认是

  constructor({ targetClass, containerDom, cb, option }) {
    if (!containerDom || !targetClass) {
      console.log(
        targetClass,
        containerDom,
        '缺少必传参数containerDom||targetClass'
      );
      return;
    }
    if (typeof cb !== 'function') {
      console.log(cb, '回调函数cb必须是一个function');
      return;
    }
    this.targetClass = targetClass || '';
    if (typeof containerDom === 'string') {
      this.containerDom = document.querySelectorAll(containerDom)[0] || null;
    } else {
      this.containerDom = containerDom || null;
    }
    this.cb = cb;
    const { BscrollObj = null, once = true } = option || {};
    this.getClientReactFn();
    this.option = option;
    this.BscrollObj = BscrollObj;
    this.once = once;
    this.getAllTargetIdFn();
    this.scrollAllFn = () => {
      if (this.BscrollObj) {
        this.bscrollFn();
      } else {
        this.scrollFn();
      }
    };
    this.initFn();
  }
  //获取外层元素的区间
  getClientReactFn() {
    if (this.containerDom.getBoundingClientRect) {
      this.domEleClient = this.containerDom.getBoundingClientRect() || {};
    } else {
      //判断为window
      const windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      this.domEleClient = { y: 0, bottom: windowHeight };
    }
  }
  //获取所有目标的唯一值
  getAllTargetIdFn() {
    const list = document.querySelectorAll(this.targetClass) || [];
    for (var i = 0; i < list.length; i++) {
      const ele = list[i];
      const eleOnlyId = ele.getAttribute('data-id');
      this.listTargetIdArray.push(eleOnlyId);
    }
  }
  //初始化
  initFn() {
    if (window.IntersectionObserver) {
      this.getObserveDom();
    } else {
      this.getViewportDom();
      if (this.BscrollObj) {
        //使用了滚动插件
        this.BscrollObj.on('scrollEnd', this.scrollAllFn);
      } else {
        //没有使用滚动插件
        this.containerDom.addEventListener('scroll', this.scrollAllFn);
      }
    }
  }
  //更新
  UpDataFn(targetClass, containerDom, cb) {
    this.targetClass = targetClass || this.targetClass;
    this.cb = cb || this.cb;
    if (typeof containerDom === 'string') {
      this.containerDom =
        document.querySelectorAll(containerDom)[0] || this.containerDom;
    } else {
      this.containerDom = containerDom || this.containerDom;
    }
    this.reset();
    if (this.containerDom) {
      this.getClientReactFn();
    }
    this.listTargetIdArray = [];

    if (window.IntersectionObserver) {
      this.getObserveDom();
    } else {
      this.getViewportDom();
    }
  }
  //Bscroll 滚动结束执行方法
  bscrollFn() {
    if (this.timeout) return;
    this.timeout = setTimeout(() => {
      this.getViewportDom();
      clearTimeout(this.timeout);
      this.timeout = null;
    }, 1000);
  }
  //scroll滚动方法
  scrollFn() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getViewportDom();
    }, 1000);
  }
  //  支持IntersectionObserver 使用该方法，担存在兼容性问题，intersection-observer可以下载使用
  getObserveDom() {
    const { observerOption = {}, threshold = 0.5, once = true } = this.option;
    const cb = this.cb;
    const option = { threshold, ...observerOption };
    this.observer = new IntersectionObserver(isInObserve, option);
    const item = document.querySelectorAll(this.targetClass);
    for (let i = 0; i < item.length; i++) {
      this.observer.observe(item[i]);
    }
    function isInObserve(entries, observer) {
      //console.log(entries, observer, item, '>>>>>>')
      entries.forEach((item) => {
        // 遍历entries数组
        if (item.isIntersecting) {
          // 当前元素可见
          //console.log(item, '<<<<')
          // 派发事件在可视区域内
          cb(item.target);
          if (once) {
            observer.unobserve(item.target); // 停止观察当前元素 避免不可见时候再次调用callback函数
          }
        }
      });
    }
  }

  // 不兼容IntersectionObserver DOM 需要绑定滚动事件
  // 可视区域元素
  getViewportDom() {
    const { threshold = 0.5 } = this.option;
    if (!this.containerDom) return;
    const { y: listTop = 0, bottom: listBottom = 0 } = this.domEleClient || {};
    const item = document.querySelectorAll(this.targetClass);
    const { offsetHeight: itemOffsetHeight = 0 } = item[0] || {};
    const visibTop = listTop - itemOffsetHeight * (1 - threshold) - 2; // 可视区域的顶部区间
    const visibBottom = listBottom - itemOffsetHeight * threshold; // 可视区域的底部区间
    // const { scrollTop = 0 } = shopListBox || {};
    for (let i = 0; i < item.length; i++) {
      const { y: itemTop } = item[i].getBoundingClientRect();
      const targetOnlyId = item[i].getAttribute('data-id');

      if (itemTop > visibTop && itemTop < visibBottom) {
        //const targetOnlyId = item[i].getAttribute(targetId);
        if (!this.targetIdArray.includes(targetOnlyId)) {
          console.log(this.targetIdArray, 'this.targetIdArray');
          this.targetIdArray.push(targetOnlyId);
          this.cb(item[i]);
          console.log(targetOnlyId, '曝光的埋点');
        }
      } else {
        if (!this.once && this.targetIdArray.includes(targetOnlyId)) {
          const targetIndex = this.targetIdArray.indexOf(targetOnlyId);
          this.targetIdArray.splice(targetIndex, 1);
        }
      }
    }
  }
  //检测列表是否发生变化
  updateObserve() {
    const newListDom = document.querySelectorAll(this.targetClass);
    const newListTargetIdArray = [];
    for (let i = 0; i < newListDom.length; i++) {
      const ele = newListDom[i];
      const targetOnlyId = ele.getAttribute('data-id');
      newListTargetIdArray.push(targetOnlyId);
      if (!this.listTargetIdArray.includes(targetOnlyId)) {
        if (window.IntersectionObserver) {
          this.observer.observe(ele);
        }
      }
    }
    //上一次曝光过的埋点删除被替换掉不存在的;
    this.targetIdArray = this.targetIdArray.filter((item) => {
      return newListTargetIdArray.includes(item);
    });

    if (!window.IntersectionObserver) {
      this.getViewportDom();
    }
    this.listTargetIdArray = newListTargetIdArray;
  }

  //列表发生变化，新增数据
  addObserve(dom) {
    const targetOnlyId = dom.getAttribute('data-id');
    this.listTargetIdArray.push(targetOnlyId);
    if (window.IntersectionObserver) {
      this.observer.observe(dom);
    } else {
      this.getViewportDom();
    }
  }
  //重置
  reset() {
    if (this.observer) {
      // 终止对所有目标元素可见性变化的观察。
      this.observer.disconnect(); //停止观察所有
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.observer = null;
    this.targetIdArray = [];
  }
  //销毁
  destroy() {
    this.reset();
    if (this.BscrollObj) {
      this.BscrollObj.off('scrollEnd', this.scrollAllFn);
    }
    if (this.containerDom) {
      this.containerDom.removeEventListener('scroll', this.scrollAllFn);
    }
    this.targetClass = '';
    this.cb = null;
    this.options = null;
    this.timeout = null;
    this.containerDom = null;
    this.domEleClient = {};
    this.BscrollObj = null;
    this.listTargetIdArray = [];
    this.scrollAllFn = null;
    this.once = true;
  }
}
function viewPortLogFn(option) {
  return new ViewPortLog(option);
}
export default viewPortLogFn;
